module Shared.Admin.Tags.Create
open System
open Illy.SafeStack

type DTO = 
    {
        Name: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations

    type NameValidations = 
        | StringValidations of StringValidations
        | MustBeUnique

    module NameValidations = 
        let toString = 
            function 
            | StringValidations v -> v.toString()
            | MustBeUnique -> "Another tag with the same name already exists."

    let validateDTO (tags: Domain.Tag list) (dto: DTO) =
        validate {
            return! (validateString 255 true >-> NameValidations.StringValidations) dto.Name
            return! !!(error MustBeUnique)
                >>= passIfNone dto.Name 
                >>= conditional pass 
                    (fun (_, nameStr) -> 
                        tags 
                        |> List.exists (fun x -> x.Name.ToLowerInvariant() = nameStr.ToLowerInvariant()) 
                        |> not 
                    )
                |> firstResult
        }

type FailureReason = 
    | FailedValidations of Validation.ValidationResult<Validations.NameValidations, Validation.NoWarning>
    